import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Circle Plus Icon - A plus sign inside a circle
 * Used for add/create actions, column configuration, etc.
 */
@Component({
  selector: 'lib-circle-plus-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [style.color]="color()"
      [class]="iconClass()"
      fill="none">
      <path
        d="M9.99935 18.9577C5.05768 18.9577 1.04102 14.941 1.04102 9.99935C1.04102 5.05768 5.05768 1.04102 9.99935 1.04102C14.941 1.04102 18.9577 5.05768 18.9577 9.99935C18.9577 14.941 14.941 18.9577 9.99935 18.9577ZM9.99935 2.29102C5.74935 2.29102 2.29102 5.74935 2.29102 9.99935C2.29102 14.2493 5.74935 17.7077 9.99935 17.7077C14.2493 17.7077 17.7077 14.2493 17.7077 9.99935C17.7077 5.74935 14.2493 2.29102 9.99935 2.29102Z"
        [attr.fill]="fill()" />
      <path
        d="M13.3327 10.625H6.66602C6.32435 10.625 6.04102 10.3417 6.04102 10C6.04102 9.65833 6.32435 9.375 6.66602 9.375H13.3327C13.6743 9.375 13.9577 9.65833 13.9577 10C13.9577 10.3417 13.6743 10.625 13.3327 10.625Z"
        [attr.fill]="fill()" />
      <path
        d="M10 13.9577C9.65833 13.9577 9.375 13.6743 9.375 13.3327V6.66602C9.375 6.32435 9.65833 6.04102 10 6.04102C10.3417 6.04102 10.625 6.32435 10.625 6.66602V13.3327C10.625 13.6743 10.3417 13.9577 10 13.9577Z"
        [attr.fill]="fill()" />
    </svg>
  `,
})
export class CirclePlusIconComponent extends BaseIconComponent {}
